import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import validate from "validate.js";

import {
  fetchUtteranceClusterData,
  fetchDropdownIntents,
  fetchDropdownEntities,
  fetchUtteranceData,
  saveFeedback,
  resetFeedbackSaveStatus,
  saveClusterFeedback,
  saveEntityType
} from "../../redux/actions/utterance";
import { pushMessage, removeMessage } from "../../redux/actions/commonActions";

// Externals
import PropTypes from "prop-types";

// Material helpers
import { withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import { Box, Paper, CircularProgress, Select, InputLabel, FormControl, MenuItem } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
// // Shared layouts
import { Dashboard as DashboardLayout } from "layouts";

// Dependencies
import MomentUtils from "@date-io/moment";
// Custom components

import { ClusterData } from "./components";
import AllUtterances from "./components/IntentClassification"

// Component styles
import styles from "./styles";
import { clusterUtterances, allUtterances } from "./schema";

// Site config
import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()

var endDate = moment();
var startDate = moment().add(-7, "days");
const config = require("../../app_configuration").CONFIGURATION[environment];

class UtteranceTraining extends Component {
  signal = true;

  state = {
    isLoading: false,
    values: {
      groupBy: "utterance",
      numOfClusters: "",
      tenant: "",
      query: "",
      fromDate: startDate,
      toDate: endDate,
      completeHistory: false,
      from: 0,
      limit: 25,
      order: true
    },
    errors: {
      groupByCluster: null,
      numOfClusters: null,
      tenant: null,
      query: null,
      completeHistory: null,
      fromDate: null,
      toDate: null,
      order: null
    },
    touched: {
      numOfClusters: false
    },
    isValid: true,
    showInit: true,
    searchedTenant: null,
    searchedType: ""
  };

  componentWillMount() {
    var newState = { ...this.state.values };
    newState["tenant"] =
      this.props.tenant === undefined || this.props.tenant === ""
        ? this.props.cognitoUser.attributes["custom:tenant"]
        : this.props.tenant;
    this.setState({
      values: newState
    });
  }

  componentWillUnmount() {}

  handleChange = e => {
    const newState = { ...this.state };
    if (e.target.id == "completeHistory" || e.target.id == "order") {
      newState.values[e.target.id] = !newState.values[e.target.id];
    } else {
      newState.values[e.target.id] = e.target.value;
    }
    newState.touched[e.target.id] = true;
    var errors = null;
    if (newState.values.groupBy === "cluster") {
      errors = validate(newState.values, clusterUtterances);
    } else {
      errors = validate(newState.values, allUtterances);
    }
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;
    this.setState(newState);
  };

  handleSelectChange = e => {
    const newState = { ...this.state };
    const newValues = {...this.state.values};
    newValues.groupBy = e.target.value;
    newValues.numOfClusters = "";
    var errors = (newState.values.groupBy === "cluster") && validate(newState.values, allUtterances);
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;
    newState.values = newValues;
    this.setState(newState);
  };

  handleDateChange = (id, value) => {
    const newState = { ...this.state };
    newState.values[id] = value;
    this.setState(newState, this.validateForm);
  };

  async onFetchClusterData() {
    this.setState({ isLoading: true, searchedTenant: this.state.values.tenant });
    await this.props.fetchUtteranceClusterData(this.state.values);
    await this.props.fetchDropdownIntents(this.state.values.tenant);
    this.setState({ isLoading: false, showInit: false, searchedType: this.state.values.groupBy });
  }

  async onFetchUtteranceData(fromValue) {
    const newState = { ...this.state };
    newState.values.from = fromValue;
    newState.searchedTenant = newState.values.tenant;
    newState.isLoading = fromValue===0?true:false;
    this.setState(newState);
    this.fetchIntents();
    await this.props.fetchUtteranceData(this.state.values);
    this.setState({ isLoading: false, 
                    showInit: false,
                    searchedType: this.state.values.groupBy });
  }

  loadMoreUtteranceData = fromValue => {
    this.onFetchUtteranceData(fromValue);
  };

  fetchIntents = async () => {
    await this.props.fetchDropdownIntents(this.state.values.tenant); 
  }

  fetchEntities = async () => {
    await this.props.fetchDropdownEntities(this.state.values.tenant); 
  }

  saveEntity = async (entity, role) => {
    await this.props.saveEntityType(entity, role, this.state.values.tenant);
  }

  changeLimitHandler = (limitValue) => {
    const newState = { ...this.state };
    newState.values.limit = limitValue;
    newState.values.from = 0;
    this.setState(newState);
    this.onFetchUtteranceData(this.state.values.from);
  };

  saveFeedback = async (data, showLoadingCircle) => {

    var feedback = [];
    var ids = [];
    var utterances = new Set();
    _.forEach(data, (utterance, index) => {
      var item = {
        Utterance: utterance["Utterance"] ? utterance["Utterance"] : null,
        IntentId: utterance["IntentId"] ? utterance["IntentId"] : null,
        UserInput: utterance["UserInput"],
        MatchedInput: utterance["MatchedQuestion"],
        PublicChatbot: false,
        Tenant: this.state.searchedTenant,
        Feedback: utterance["Feedback"],
        SimilarityScore: utterance["SimilarityScore"]
      };

      if (utterance["Id"]) ids.push(utterance["Id"]);
      if (utterance["Feedback"]!="hide") feedback.push(item);
      utterances.add(utterance["UserInput"]);
    });
    this.props.pushMessage({
      message: "Saving data don't leave the page",
      type: "info"
    });
    if (this.state.values.groupBy === "cluster") {
      await this.props.saveClusterFeedback(feedback, this.state.values, [...utterances]);
    } else {
      await this.props.saveFeedback(feedback, ids, this.state.values);
    }
    if (this.props.feedbackSuccessfullySaved) {
      this.props.pushMessage({
        message: "Utterance/Question training data saved successfully!",
        type: "success"
      });
    } else {
      this.props.pushMessage({
        message: "Error during save process. Utterance/Question data not saved!",
        type: "error"
      });
    }
    if (showLoadingCircle) {
      const newState = { ...this.state };
      newState.isLoading = false;
      this.setState(newState);
    }
  };

  validateBeforeSubmit = () => {
    var newState = { ...this.state.values };
    var errors = validate(newState, clusterUtterances);
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;
    this.setState(newState);
    return errors ? false : true;
  };

  callSearchAction = () => {
    if (this.state.values.groupBy === "cluster") {
      if(this.validateBeforeSubmit()){
          this.onFetchClusterData();
      }
    }else if(this.state.values.groupBy === "intent"){
      this.onFetchClusterData();
    }else{
      this.onFetchUtteranceData(0); 
    }
  };

  onSearchClick = e => {
    e.preventDefault();

    if (!this.state.isValid) return;
    if (!this.state.values.tenant) {
      const stateValuesWithTenant = { ...this.state.values, tenant: this.props.tenant };
      // todo Update of tenant in state should probably go in some method which waits for props updates
      this.setState(
        {
          values: stateValuesWithTenant
        },
        this.callSearchAction
      );
      return;
    }
    this.callSearchAction();
  };
  /**
   * Hide tenant input in each environment except development.
   * Note that we don't want the input gone, just hidden.
   * This is because it takes its default value from state which is used for the API call.
   */
  getTenantInputStyles = () => {
    if (environment === "development") {
      return {};
    }
    return { display: "none" };
  };

  render() {
    const { classes, utterances, utteranceClusterData } = this.props;
    const { values, errors, isLoading, showInit, searchedType } = this.state;
    const showNumOfClustersError = errors.numOfClusters ? errors.numOfClusters[0] : false;
    const showTenantError = errors.tenant ? errors.tenant[0] : false;
    const showFromDateError = errors.fromDate ? errors.fromDate[0] : false;
    const showToDateError = errors.toDate ? errors.toDate[0] : false;
    const tenantInputStyles = this.getTenantInputStyles();
    return (
      <DashboardLayout title="Utterance Training">
        <div className={classes.container}>
          <Paper className={classes.searchContainer} elevation={1}>
            <Typography variant="h4" component="h4">
              Search Filter:
            </Typography>

            <Box className={classes.filterItems}>
              <FormControl variant="outlined" className={classes.inputWrapper}>
                <InputLabel id="selId">Group by</InputLabel>
                <Select
                  labelId="selId"
                  value={values.groupBy}
                  label="Group by"
                  onChange={e => this.handleSelectChange(e)}
                  >
                    <MenuItem value="cluster">
                      Cluster
                    </MenuItem>
                    <MenuItem value="utterance">
                      Utterance
                    </MenuItem>
                    <MenuItem value="intent">
                      Intent
                    </MenuItem>
                </Select>
              </FormControl>

              <Box className={classes.inputWrapper}>
                <TextField
                  id="numOfClusters"
                  className={classes.textfield}
                  variant="outlined"
                  disabled={values.groupBy!=="cluster"}
                  label="Num of clusters"
                  InputLabelProps={{ shrink: true }}
                  onChange={this.handleChange}
                  value={values.numOfClusters}
                  inputProps={{ maxLength: 150 }}
                  type="number"
                />
                {showNumOfClustersError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.numOfClusters[0]}
                  </Typography>
                )}
              </Box>

              <Box style={tenantInputStyles} className={classes.inputWrapper}>
                <TextField
                  id="tenant"
                  className={classes.textfield}
                  variant="outlined"
                  label="Tenant"
                  onChange={this.handleChange}
                  value={values.tenant}
                  inputProps={{ maxLength: 150 }}
                />
                {showTenantError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.tenant[0]}
                  </Typography>
                )}
              </Box>

              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  autoOk
                  id="fromDate"
                  inputVariant="outlined"
                  className={classes.fromDatePicker}
                  label="From date:"
                  value={values.fromDate}
                  disabled={values.completeHistory}
                  format="MM/DD/YYYY"
                  onChange={event => this.handleDateChange("fromDate", event)}
                  maxDate={endDate}
                  showTodayButton
                />
                {showToDateError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.toDate[0]}
                  </Typography>
                )}

                <DatePicker
                  autoOk
                  id="toDate"
                  inputVariant="outlined"
                  label="To date:"
                  className={classes.toDatePicker}
                  value={values.toDate}
                  disabled={values.completeHistory}
                  format="MM/DD/YYYY"
                  onChange={event => this.handleDateChange("toDate", event)}
                  maxDate={endDate}
                  showTodayButton
                  disableFuture
                />
                {showFromDateError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.fromDate[0]}
                  </Typography>
                )}
              </MuiPickersUtilsProvider>

              <Box mt="25px" width="100%" textAlign="start">
                <FormControlLabel
                  control={
                    <Checkbox
                      id="completeHistory"
                      onChange={this.handleChange}
                      checked={values.completeHistory}
                      color="primary"
                      inputProps={{
                        "aria-label": "secondary checkbox"
                      }}
                    />
                  }
                  className={classes.checkBoxField}
                  label="Search complete history"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      id="order"
                      disabled={values.groupBy === "cluster" || values.groupBy === "intent"}
                      onChange={this.handleChange}
                      checked={values.order}
                      color="primary"
                    />
                  }
                  className={classes.checkBoxField}
                  label="Descending order"
                />
                <div className={classes.searchButton}>
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    className={classes.button}
                    onClick={this.onSearchClick}
                  >
                    Search
                  </Button>
                </div>
              </Box>
            </Box>
          </Paper>

          {isLoading && <CircularProgress disableShrink={true} />}
          {!showInit && !isLoading && (
            <Box display="flex">
              <Paper className={classes.dataContainer} elevation={1}>
                <div>
                  {(searchedType === "utterance")?(
                    <React.Fragment>
                      <AllUtterances
                        data={utterances}
                        loadMoreData={this.loadMoreUtteranceData}
                        changeLimit={this.changeLimitHandler}
                        saveFeedback={this.saveFeedback}
                        currentPage={(values.from + values.limit) / values.limit}
                        limit={values.limit}
                        fetchDropdownIntents={this.fetchIntents}
                        fetchDropdownEntities={this.fetchEntities}
                        saveEntityType={this.saveEntity}
                      />
                    </React.Fragment>
                  ):(
                    <ClusterData 
                      data={utteranceClusterData} 
                      saveFeedback={this.saveFeedback} 
                      saveEntityType={this.saveEntity}
                      groupByIntent={values.groupBy === "intent"}
                      fetchDropdownIntents={this.fetchIntents}
                      fetchDropdownEntities={this.fetchEntities}
                       />
                  ) }
                </div>
              </Paper>
            </Box>
          )}
        </div>
      </DashboardLayout>
    );
  }
}

UtteranceTraining.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    utterances: !_.isEmpty(state.utterance.utterances) ? state.utterance.utterances : null,
    dropdownEntities: !_.isEmpty(state.utterance.dropdownEntities) ? state.utterance.dropdownEntities : null,
    dropdownIntents: !_.isEmpty(state.utterance.dropdownIntents) ? state.utterance.dropdownIntents : null,
    utteranceClusterData: !_.isEmpty(state.utterance.utteranceClusterData)
      ? state.utterance.utteranceClusterData
      : null,
    feedbackSuccessfullySaved: !_.isEmpty(state.utterance) ? state.utterance.saved : null,
    tenant: state.skill.tenant
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchUtteranceClusterData,
        fetchUtteranceData,
        fetchDropdownIntents,
        fetchDropdownEntities,
        saveFeedback,
        saveClusterFeedback,
        saveEntityType,
        resetFeedbackSaveStatus,
        pushMessage,
        removeMessage
      },
      dispatch
    ),
    dispatch
  };
}
UtteranceTraining = connect(
  mapStateToProps,
  mapDispatchToProps
)(UtteranceTraining);

// export default withStyles(subscriptionCommon.styles)(Subscription);
export default withStyles(styles)(UtteranceTraining);
